import { createContext, useContext } from 'react';
import { PURCHASE_REQUESTS_CHANNEL } from '../models/channels';
import type { FormsChannel } from '../models/channels';

/**
 * The forms screen a page is drawn for: Purchase Requests, the only one since Default Template Forms was removed
 * (2026-10-16). The Purchase Requests routes still provide it explicitly around the pages.
 */
export const FormsChannelContext = createContext<FormsChannel>(PURCHASE_REQUESTS_CHANNEL);

export function useFormsChannel(): FormsChannel {
  return useContext(FormsChannelContext);
}
